import { cookies } from "./cookies";

const consentMap = {
  performanceCookie: "C0002",
  functionalCookie: "C0003",
  targetingCookie: "C0004",
};

const getCookieConsents = (code: string) => {
  // 1 for enabled, 0 for disabled
  const value = cookies.get("OptanonConsent") || "";
  return value.includes(`${code}:1`);
};

export const isPerformanceCookieConsentGranted = () =>
  getCookieConsents(consentMap.performanceCookie);
